import Constants from "./constants";
import { createStore } from "redux";

const initialState = {
  hydrated: false,
  account: null,
  accountLoadState: "inactive",

  platformAlerts: [],
};
const reducer = function (state = initialState, action) {
  if (action.type === Constants.RESET_STORE) {
    return Object.assign({}, initialState);
  }

  if (action.type === Constants.FETCH_ACCOUNT) {
    return Object.assign({}, state, {
      accountLoadState: "loading",
      hydrated: false,
    });
  }

  if (action.type === Constants.FETCH_ACCOUNT_RESPONSE) {
    const account = action.data
      ? Object.assign({}, state.account, action.data)
      : null;
    return Object.assign({}, state, {
      account,
      accountLoadState: account ? "loaded" : "inactive",
      hydrated: true,
      validation: action.validation,
    });
  }

  if (action.type === Constants.LOGOUT_RESPONSE) {
    return Object.assign({}, initialState, {
      account: null,
      accountLoadState: "inactive",
    });
  }

  if (action.type === Constants.FETCH_ALERTS_RESPONSE) {
    return Object.assign({}, state, {
      platformAlerts: action.data,
    });
  }

  if (action.type === Constants.HIDE_PLATFORM_ALERT) {
    return Object.assign({}, state, {
      platformAlerts: null,
    });
  }

  return state;
};

export default createStore(reducer);



// WEBPACK FOOTER //
// ./client/pages/main/store.js